import produce from "immer";
import { bookingActions } from ".";
import { IStoreState } from "../initialStoreState";
import { initialBookingState } from "./booking.types";
import { CLEAR_BOOKING_STATE, FETCH_BOOKING_LIST_FAILED, FETCH_BOOKING_LIST_PROGRESS, FETCH_BOOKING_LIST_SUCCESS } from "./bookingActions";
import { LoadState } from "../../constants/enums";


export const bookingReducer = (
  state: IStoreState["booking"] = initialBookingState,
  action: bookingActions
) => {
  switch (action.type) {
    case FETCH_BOOKING_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = []
      });
      return newState;
    }
    case FETCH_BOOKING_LIST_SUCCESS: {
      const { data,totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_BOOKING_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = []
      });
      return newState;
    }
    case CLEAR_BOOKING_STATE: {
      return initialBookingState;
    }
    default:
      return state;
  }
};
